import { render, staticRenderFns } from "./DeAsideContainer.vue?vue&type=template&id=0dc6f361&scoped=true"
import script from "./DeAsideContainer.vue?vue&type=script&lang=js"
export * from "./DeAsideContainer.vue?vue&type=script&lang=js"
import style0 from "./DeAsideContainer.vue?vue&type=style&index=0&id=0dc6f361&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc6f361",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dc6f361')) {
      api.createRecord('0dc6f361', component.options)
    } else {
      api.reload('0dc6f361', component.options)
    }
    module.hot.accept("./DeAsideContainer.vue?vue&type=template&id=0dc6f361&scoped=true", function () {
      api.rerender('0dc6f361', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dataease/DeAsideContainer.vue"
export default component.exports